export default __webpack_public_path__ + "static/media/2_Still.0fd2dd2f.jpg";